// ADVANCE QUALITY COLLASPE SCRIPT START
$(document).ready(function () {
  const selectors =
    '.facets__disclosure-vertical[data-index="9"] .filter-label, .facets__disclosure-vertical[data-index="9"] ul, .facets__disclosure-vertical[data-index="10"] .filter-label, .facets__disclosure-vertical[data-index="10"] ul';

  $(selectors).each(function () {
    this.style.setProperty("display", "none", "important");
  });

  $(".adavance-quality-collaspe").on("click", function () {
    const isActive = $(this).hasClass("adavance-quality-collaspe-ac");

    $(".adavance-quality-collaspe").removeClass("adavance-quality-collaspe-ac");
    $(selectors).each(function () {
      this.style.setProperty("display", "none", "important");
    });
    if (!isActive) {
      $(this).addClass("adavance-quality-collaspe-ac");
      $(selectors).each(function () {
        this.style.setProperty("display", "flex", "important");
      });
    }
  });
});

// MOBILE FILTER DRAWER SCRIPT START
document.addEventListener("DOMContentLoaded", function () {
  const popupBtn = document.querySelector(".facet-btn");
  const popup = document.querySelector(".mobile-filter-drawer");
  const overlay = document.querySelector(".light-d-overlay");
  const closeBtn = document.querySelector(".filter-close-btn");

  function openPopup() {
    popup.classList.remove("closing");
    popup.classList.add("open");
    document.body.classList.add("js-popup-open");
  }

  function closePopup() {
    popup.classList.add("closing");
    popup.classList.remove("open");
    document.body.classList.remove("js-popup-open");

    setTimeout(() => {
      popup.classList.remove("closing");
    }, 400);
  }

  if (popupBtn) popupBtn.addEventListener("click", openPopup);
  if (closeBtn) closeBtn.addEventListener("click", closePopup);
  if (overlay) overlay.addEventListener("click", closePopup);
});
